<template>
  <div class="container">
    <div
      tabindex="-1"
      class="button"
      @click="open_modal = true"
      :data-tooltip="$t('social_share.title')"
      ontouchstart
    >
      <!-- <div class="icon"></div> -->
      <i class="icon fab fah fa-lg fas" aria-hidden="true"></i>
    </div>
    <ModalSocialShare
      v-if="open_modal"
      @cancel="open_modal = false"
      :sharing="sharing"
      :networks="networks"
    />
  </div>
</template>

<script>
export default {
  props: {
    sharing: {
      type: Object,
      required: false,
    },
    networks: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      open_modal: false,
    };
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  position:relative;
  justify-content: center;
  align-items: center;
  margin-block: unset;
}

.button {
  /*width: 50px;
  height: 20px;*/
  border-radius: 5px;
  text-align: center;
  /*background: #cccccc;*/
  cursor: pointer;
}

.icon {
  font-size: 25px;
  vertical-align: bottom;

  // Image
  width: 28px;
  height: 28px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/img/btn/paper-plane.png");
}

.button:hover::before,
.button:active::before,
.button:focus::before {
  content: attr(data-tooltip);
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateX(-100%) translateY(-50%);
  background-color: black;
  color: white;
  border-radius: 0.5rem;
  padding: 0.3rem 0.5rem;
  font-size: 0.8rem;
}
</style>
